import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import * as atoms from '../../../atoms/atoms';
import useCachedEnvironments from '../../../hooks/useCachedEnvironments';
import { isInSaaSMode } from '../../../utils/common';
import { CHAT_MODES } from '../constants';
import { ChatMode } from '../types';

const ALL_MODES = CHAT_MODES.map((m) => m.key);

const useAvailableModes = (): ChatMode[] => {
  const selectedEnvId = useRecoilValue(atoms.selectedEnvironmentId);
  const { data: environmentsData } = useCachedEnvironments();

  return useMemo((): ChatMode[] => {
    if (!isInSaaSMode()) {
      return ALL_MODES;
    }

    const chatModes = environmentsData?.find(
      (env) => env.id === selectedEnvId,
    )?.chatModes;

    if (!chatModes) {
      return ['ask'];
    }

    return ALL_MODES.filter((mode) => chatModes.includes(mode));
  }, [environmentsData, selectedEnvId]);
};

export default useAvailableModes;
